import { Component, OnChanges, OnInit, inject, input, output } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { TooltipDirective, TooltipPosition } from '../../../../core/directives/tooltip';
import { enUS, he } from 'date-fns/locale';
import { AppTranslateService } from '../../../../core/services/app.translate.service';
import { DateFnsAdapter } from '@angular/material-date-fns-adapter';
import { IErrorMessage } from '../../../../core/types/general';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

const DATA_FORMAT = {
  parse: {
    dateInput: 'dd.MM.yyyy',
  },
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

@Component({
  selector: 'app-datepicker',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatIconModule,
    TooltipDirective,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: DateFnsAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: DATA_FORMAT },
  ],
  templateUrl: './datepicker.component.html',
  styleUrl: './datepicker.component.scss',
})
export class DatepickerComponent implements OnInit, OnChanges {
  private dateAdapter = inject(DateAdapter);
  private appTranslate = inject(AppTranslateService);

  protected readonly Validators = Validators;
  protected readonly TooltipPosition = TooltipPosition;

  errorMessages = input<IErrorMessage[]>([]);
  hintMessage = input<string | null>();
  className = input.required<string>();
  datePickerControl = input.required<FormControl>();
  label = input<string>();
  placeholder = input<string>();
  minDate = input<Date | string>();
  maxDate = input<Date | string>();
  hideRequiredMarker = input<boolean>(false);
  readonly = input<boolean>(false);
  infoTooltip = input<string | null>('');
  pickerChangesEvent = output<MatDatepickerInputEvent<Date>>();

  ngOnInit() {
    this.setLocale();
  }

  ngOnChanges() {
    this.setLocale();
  }

  private setLocale() {
    const currentLang = this.appTranslate.getCurrentLanguage();
    const locale = currentLang === 'he' ? he : enUS;
    this.dateAdapter.setLocale(locale);
  }

  getFirstError() {
    return this.errorMessages().find((e) => this.datePickerControl().hasError(e.errorName) && this.datePickerControl().touched);
  }
}
